import { plainToClass } from "class-transformer";
import { Appendix } from "../../../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../../../shared/entities/scripts/study";
import { FilterOption } from "../../../../../../shared/scripts/filtering/filtering.entities";
import { SetActiveTab } from "../../../../../../shared/scripts/tab-utilities";
import { SiteInfo } from "../../../../sites/shared/sites.entities";
import { ISiteInfo } from "../../../scripts/data-completeness.page";
import { AssessmentsDatatableEntry } from "../../assessments-tab/assessments-datatable-view/assessments-datatable.entities";
import { AssessmentLookup } from "../../assessments-tab/scripts/assessments.lookup";
import { SamplesDatatableView } from "../samples-datatable-view/samples-datatable-view";
import { SamplesDatatableEntry } from "../samples-datatable-view/samples-datatable.entities";
import { SamplesSummaryView } from "../samples-summary-view/samples-summary-view";
import { SamplesSummarySeries } from "../samples-summary-view/samples-summary.entities";
import { Samples, SamplesEvent } from "./samples.entities";
import { SamplesLookup } from "./samples.lookup";
import { VisitLookup } from "../../visits-tab/scripts/visits.lookup";

export class SamplesController {
    siteInfo: ISiteInfo;

    allTimepoints: Samples[] = [];
    allSamples: Samples[] = [];
    allSamplesEvents: SamplesEvent[] = [];
    // allVisitRequired: FilterOption[] = [];

    summaryView: SamplesSummaryView;
    datatableView: SamplesDatatableView;

    constructor(siteInfo: ISiteInfo, samplesJson: any) {

        this.siteInfo = siteInfo;

        let foundSamplesIds: number[] = [];
        let foundTimepointIds: number[] = [];

        //console.log("JSON Sample", samplesJson[0]);
        this.allSamplesEvents = plainToClass(SamplesEvent, <SamplesEvent[]>samplesJson);
        
        const visitIds = new Set<number>();
        this.allSamplesEvents.forEach(e => visitIds.add(e.VisitAbb));
        //console.log(" All VisitFullNIds found in data:", Array.from(visitIds).sort((a, b) => a - b));

        for (let i = 0; i < this.allSamplesEvents.length; ++i) {

            let v = this.allSamplesEvents[i];

            v.initialize();

            if (foundSamplesIds.indexOf(v.BiospecId) == -1) {
                this.allSamples.push(new Samples(v.BiospecId, SamplesLookup.GetSampleColumn(v.BiospecId), SamplesLookup.GetSampleOrdering(v.BiospecId)));
                foundSamplesIds.push(v.BiospecId);
            }

            if (!foundTimepointIds.includes(v.VisitAbb)) {
                this.allTimepoints.push(new Samples(v.VisitAbb, VisitLookup.GetVisitMasterColumn(v.VisitAbb), VisitLookup.GetVisitMasterOrdering(v.VisitAbb)));
                foundTimepointIds.push(v.VisitAbb);
                }
        }
        this.allSamples.sort((a: Samples, b: Samples) => a.OrderBy - b.OrderBy);
        this.allTimepoints.sort((a: Samples, b: Samples) => a.OrderBy - b.OrderBy);

        this.summaryView = new SamplesSummaryView();
        this.datatableView = new SamplesDatatableView();
    }

    FilterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[], visitIds: number[], samplesIds: number[], timepointIds: number[]): void {
        let byVisitSummaryMap: Map<number, SamplesSummarySeries> = new Map<number, SamplesSummarySeries>();
        let bySiteSummaryMap: Map<number, SamplesSummarySeries> = new Map<number, SamplesSummarySeries>();
        let bySamplesSummaryMap: Map<number, SamplesSummarySeries> = new Map<number, SamplesSummarySeries>();

        let noGroupingDataMap: Map<string, SamplesDatatableEntry> = new Map<string, SamplesDatatableEntry>();
        let groupingByVisitDataMap: Map<string, SamplesDatatableEntry> = new Map<string, SamplesDatatableEntry>();
        let groupingBySiteDataMap: Map<string, SamplesDatatableEntry> = new Map<string, SamplesDatatableEntry>();
        let groupingBySamplesDataMap: Map<string, SamplesDatatableEntry> = new Map<string, SamplesDatatableEntry>();

        //console.log("Selected Sample filter", {
        //    studyIds, appendixIds, siteIds, visitIds, samplesIds, timepointIds
        //});

        for (let i = 0; i < this.allSamplesEvents.length; ++i) {
            let visit: SamplesEvent = this.allSamplesEvents[i];
            //if (visit.SamplesStatusId === 6) {
            //    console.log("Found Overdue status: ", visit);
            //}
            //if (visit.SamplesStatusId === 4 && visit.VisitFullNId === 1 && visit.BiospecId === 5) {
            //    console.log("For status Not Done and Baseline visit for SKINBIOP", visit);
            //}

            if (!studyIds.includes(visit.StudyId) ||
                !appendixIds.includes(visit.AppendixId) ||
                !samplesIds.includes(visit.BiospecId) ||
                !timepointIds.includes(visit.VisitAbb) ||
                !siteIds.includes(visit.SiteNumber)) {
                continue;
            }
            //console.log("Passed all filters: ", visit);

            //Summary View Data
            let visitSeries: SamplesSummarySeries;
            if (byVisitSummaryMap.has(visit.VisitAbb)) { visitSeries = byVisitSummaryMap.get(visit.VisitAbb); }
            else { visitSeries = new SamplesSummarySeries(VisitLookup.GetVisitMasterColumn(visit.VisitAbb), "visit", visit.VisitAbb); }
            visitSeries.addSamplesEvent(visit);
            byVisitSummaryMap.set(visit.VisitAbb, visitSeries);

            let sampleSeries: SamplesSummarySeries;
            if (bySamplesSummaryMap.has(visit.BiospecId)) { sampleSeries = bySamplesSummaryMap.get(visit.BiospecId); }
            else { sampleSeries = new SamplesSummarySeries(SamplesLookup.GetSampleColumn(visit.BiospecId), "sample", visit.BiospecId); }
            sampleSeries.addSamplesEvent(visit);
            //console.log("Adding to sampleSeries: ", visit.SamplesStatusId, visit);
            bySamplesSummaryMap.set(visit.BiospecId, sampleSeries);

            let siteSeries: SamplesSummarySeries;
            if (bySiteSummaryMap.has(visit.SiteNumber)) { siteSeries = bySiteSummaryMap.get(visit.SiteNumber); }
            else { siteSeries = new SamplesSummarySeries(this.siteInfo.GetSiteName(visit.SiteNumber), "site", visit.SiteNumber); }
            siteSeries.addSamplesEvent(visit);
            bySiteSummaryMap.set(visit.SiteNumber, siteSeries);

            //Datatable View Data
            let dataHash: string;

            let noGroupingData: SamplesDatatableEntry;
            dataHash = SamplesDatatableEntry.getHash("none", visit);
            if (noGroupingDataMap.has(dataHash)) { noGroupingData = noGroupingDataMap.get(dataHash); }
            else {
                noGroupingData = new SamplesDatatableEntry(
                    Study.GetStudyName(visit.StudyId),
                    Appendix.GetAppendixName(visit.AppendixId),
                    this.siteInfo.GetSiteName(visit.SiteNumber),
                    SiteInfo.FormatSiteNumber(visit.SiteNumber),
                    VisitLookup.GetVisitMasterColumn(visit.VisitAbb),
                    SamplesLookup.GetSampleColumn(visit.BiospecId));
            }
            noGroupingData.addSamplesEvent(visit);
            noGroupingDataMap.set(dataHash, noGroupingData);

            let visitGroupingData: SamplesDatatableEntry;
            dataHash = SamplesDatatableEntry.getHash("by-visit", visit);
            if (groupingByVisitDataMap.has(dataHash)) { visitGroupingData = groupingByVisitDataMap.get(dataHash); }
            else {
                visitGroupingData = new SamplesDatatableEntry(
                    Study.GetStudyName(visit.StudyId),
                    Appendix.GetAppendixName(visit.AppendixId),
                    "All Sites",
                    "All Sites",
                    VisitLookup.GetVisitMasterColumn(visit.VisitAbb),
                    "All Biospecimens",
                    visit.VisitAbb);
            } 
            visitGroupingData.addSamplesEvent(visit);
            groupingByVisitDataMap.set(dataHash, visitGroupingData);

            let siteGroupingData: SamplesDatatableEntry;
            dataHash = SamplesDatatableEntry.getHash("by-site", visit);
            if (groupingBySiteDataMap.has(dataHash)) { siteGroupingData = groupingBySiteDataMap.get(dataHash); }
            else {
                siteGroupingData = new SamplesDatatableEntry(
                    Study.GetStudyName(visit.StudyId),
                    Appendix.GetAppendixName(visit.AppendixId),
                    this.siteInfo.GetSiteName(visit.SiteNumber),
                    SiteInfo.FormatSiteNumber(visit.SiteNumber),
                    "All Visits",
                    "All Biospecimens");
            }
            siteGroupingData.addSamplesEvent(visit);
            groupingBySiteDataMap.set(dataHash, siteGroupingData);

            let samplesGroupingData: SamplesDatatableEntry;
            dataHash = SamplesDatatableEntry.getHash("by-samples", visit);
            //console.log("By Sample Hash:", dataHash);
            if (groupingBySamplesDataMap.has(dataHash)) { samplesGroupingData = groupingBySamplesDataMap.get(dataHash); }
            else {
                samplesGroupingData = new SamplesDatatableEntry(
                    Study.GetStudyName(visit.StudyId),
                    Appendix.GetAppendixName(visit.AppendixId),
                    "All Sites",
                    "All Sites",
                    "All Visits",
                    SamplesLookup.GetSampleColumn(visit.BiospecId));
            }
            samplesGroupingData.addSamplesEvent(visit);
            groupingBySamplesDataMap.set(dataHash, samplesGroupingData);
        }
        let seriesByVisit: SamplesSummarySeries[] = [...byVisitSummaryMap.values()];
        seriesByVisit.sort((a: SamplesSummarySeries, b: SamplesSummarySeries) => a.sortValue - b.sortValue);

        let seriesBySamples: SamplesSummarySeries[] = [...bySamplesSummaryMap.values()];
        seriesBySamples.sort((a: SamplesSummarySeries, b: SamplesSummarySeries) => a.sortValue - b.sortValue);

        let seriesBySite: SamplesSummarySeries[] = [...bySiteSummaryMap.values()];
        seriesBySite.sort((a: SamplesSummarySeries, b: SamplesSummarySeries) => b.sortValue - a.sortValue);

        this.summaryView.UpdateData(seriesByVisit, seriesBySite, seriesBySamples);

        let tableEntriesNone: SamplesDatatableEntry[] = [...noGroupingDataMap.values()];
        for (let i: number = 0; i < tableEntriesNone.length; ++i) { tableEntriesNone[i].initialize(); }

        let tableEntriesBySamples: SamplesDatatableEntry[] = [...groupingBySamplesDataMap.values()];
        for (let i: number = 0; i < tableEntriesBySamples.length; ++i) { tableEntriesBySamples[i].initialize(); }

        let tableEntriesByVisit: SamplesDatatableEntry[] = [...groupingByVisitDataMap.values()];
        for (let i: number = 0; i < tableEntriesByVisit.length; ++i) { tableEntriesByVisit[i].initialize(); }
        tableEntriesByVisit.sort((a, b) => a.sortValue - b.sortValue);

        let tableEntriesBySite: SamplesDatatableEntry[] = [...groupingBySiteDataMap.values()];
        for (let i: number = 0; i < tableEntriesBySite.length; ++i) { tableEntriesBySite[i].initialize(); }

        this.datatableView.UpdateData(tableEntriesNone, tableEntriesBySamples, tableEntriesByVisit, tableEntriesBySite);
    }

    setView(newView: string): void {

        //console.log("visits.setView", newView);
        if (newView == "view-summary") { SetActiveTab("samples-tabs", "samples-summary-content"); this.summaryView.SetView("samples-summary"); }
        else if (newView == "view-datatable") { SetActiveTab("samples-tabs", "samples-datatable-content"); this.datatableView.SetView("samples-datatable"); }
        else {
            this.summaryView.SetView(newView);
            this.datatableView.SetView(newView);
        }
    }

    exportTable(): void {
        this.datatableView.exportTable();
    }
}                               